module.exports = __webpack_public_path__ + "static/lframe-caravan-loan-2821a23a2561b5421674676febf80ce2.png";